import { DateRange } from "../../types";
import {
  getRangeLastMonth,
  getRangeLastWeek,
  getRangeToday,
} from "../../utils";
import { Option } from "../options/types";

export const DATE_RANGE_OPTIONS: Array<Option<DateRange>> = [
  { value: getRangeLastMonth(), title: "ماه" },
  { value: getRangeLastWeek(), title: "هفته" },
  { value: getRangeToday(), title: "امروز" },
];
